// extracted by mini-css-extract-plugin
module.exports = {"hero":"WorkspaceHero_hero__ZMtsZ","titleStack":"WorkspaceHero_titleStack__MGU8o","actionsBelow":"WorkspaceHero_actionsBelow__yRZ_c","imageError":"WorkspaceHero_imageError__XeldZ"};